require('./noClientFallbackView.scss');

const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
// @ vendors
const React = require('react');


class NoClientFallbackView extends React.Component {
    render() {
        const poeditorPrefix = 'noClienteFallbackView';
        const linkLabel = formatText(`${poeditorPrefix}-${poeditorPrefix}_BackButton`).toUpperCase();
        const goBackButton = {
            label: linkLabel
        }

        return (
            <div className="account-direct-debit-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={[]}
                            />
                        </OKCover>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-10 col-xs-offset-1">
                                    <WizardError
                                        errorMessage={"¿Quieres hacerte cliente?"}
                                        mainButton={goBackButton}
                                        icon={'info'}
                                    >
                                        <p className="no-client-fallback-view__message">
                                            <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_MainText`} />
                                        </p>
                                    </WizardError>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

module.exports = NoClientFallbackView;
